/**
 * Order PWA - Online Ordering for Customers
 * Domain: order.chain29.com
 * 
 * Customer-facing online ordering:
 * - Browse menu
 * - Place orders for pickup/delivery
 * - Track orders
 * - Loyalty rewards
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { orderPath } from './lib/orderPath';

// Pages
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import StorefrontPage from './pages/StorefrontPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import ConfirmationPage from './pages/ConfirmationPage';
import OrderStatusPage from './pages/OrderStatusPage';

// Context providers
import { OrderProvider } from './context/OrderContext';
import { CartProvider } from './context/CartContext';

export default function OrderApp() {
  return (
    <CartProvider>
      <OrderProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="storefront/:restaurantSlug" element={<StorefrontPage />} />
          <Route path="menu" element={<MenuPage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          {/* the hosted payment page returns the customer to <the host they ordered on>/order/status/<id>?t=
              (the order's status page shows the payment until it is paid). On online. / order. this app is at
              the root, so /order/status/<id> is matched here; on chain29.com and restaurant subdomains the app
              is mounted at /order/* and status/:orderNumber matches. order/checkout?order=&t= resumes a checkout. */}
          <Route path="order/status/:orderNumber" element={<OrderStatusPage />} />
          <Route path="order/checkout" element={<CheckoutPage />} />
          <Route path="confirmation/:orderNumber" element={<ConfirmationPage />} />
          <Route path="status/:orderNumber" element={<OrderStatusPage />} />
          <Route path="order/:orderId" element={<OrderStatusPage />} />
          <Route path="*" element={<Navigate to={orderPath('')} replace />} />
        </Routes>
      </OrderProvider>
    </CartProvider>
  );
}
